var React = require('react');

function Working (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("linearGradient",{"id":"gradient"},[React.createElement("stop",{"offset":"25%","stopColor":"#9FADB5","key":0}),React.createElement("stop",{"offset":"75%","stopColor":"#9FADB5","stopOpacity":"0.5","key":1})])),React.createElement("circle",{"cx":"16","cy":"16","r":"10","fill":"#FFFFFF","key":1}),React.createElement("circle",{"id":"Oval","cx":"16","cy":"16","r":"10","fill":"url(#gradient)","key":2},React.createElement("animateTransform",{"attributeName":"transform","attributeType":"XML","type":"rotate","from":"0 16 16","to":"360 16 16","dur":"1s","repeatCount":"indefinite"})),React.createElement("circle",{"id":"Oval-4","fill":"#f3f5f6","cx":"16","cy":"16","r":"3.5","key":3})]);
}

Working.defaultProps = {"width":"32px","height":"32px","viewBox":"0 0 32 32","version":"1.1"};

module.exports = Working;

Working.default = Working;
